import request from "@/utils/request";

export function palmAvailabilityGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/PalmAvailability/GetAllForDropdown",
        method: "GET",
        params
    });
}

export function palmAvailabilityGet(params) {
    return request({
        url: "/api/services/app/PalmAvailability/Get",
        method: "GET",
        params
    });
}

export function palmAvailabilityCreate(data) {
    return request({
        url: "/api/services/app/PalmAvailability/Create",
        method: "POST",
        data
    });
}

export function palmAvailabilityUpdate(data) {
    return request({
        url: "/api/services/app/PalmAvailability/Update",
        method: "PUT",
        data
    });
}

export function palmAvailabilityDelete(params) {
    return request({
        url: "/api/services/app/PalmAvailability/Delete",
        method: "DELETE",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/palm_availability.js